<template>
  <div v-if="renderReady">
    <label v-if="getTitle" class="label">
      {{getTitle}}
      <w-tooltip v-if="tooltipContent && tooltipContent.length">{{tooltipContent}}</w-tooltip>
    </label>
    <div
      class="input"
      :class="{'state-error': model.$error, 'state-disabled': disabled && !borderless}"
    >
      <input
        ref="input"
        type="text"
        class="form-control"
        :class="{'borderless':borderless, 'text-right':model.$schema.type=='number'||model.$schema.type=='money'||model.$schema.type=='integer'}"
        :disabled="disabled"
        :readonly="model.$schema.readOnly"
        :value="svalue"
        @input="onInput($event)"
        @focus="onFocus($event)"
        @blur="onBlur($event)"
        @mouseover="mouseOver($event)"
        @mouseleave="mouseOut($event)"
        :id="model.$form.generateId ? model.$pathId : undefined"
        :name="model.$form.testPath ? model.$path : undefined"
      >
    </div>
    <w-error :model="model" @focus="$refs.input.focus();"></w-error>
  </div>
</template>

<script>
//         v-tooltip.notrigger="{content: tooltipContent, visible: !getTitle && tooltipVisibility}"

import modelMixin from '../mixins/modelMixin';
import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  components: {WError, WTooltip},
  props: {
    placeholder: String
  },
  mixins: [modelMixin],
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>

<style>
</style>